export default {
    data() {
        return {
            isyingchang: true,
            // inputBoo:true,
            inputBoo1: true,
            inputBoo2: true,
            registerMessage: '',
            registerMessage1: '',
            registerMessage3: '',
            isRegisterMessage: false,
            isRegisterMessage1: false,
            isRegisterMessage3: false,
            isLoginMessage: false,
            isIdCardMessage: false,
            loginMessage: '',
            idCardMessage: '',
            loginPhone: '',
            loginPassword: '',
            registerPassword: '',
            registerAffirmPassword: '',
            registerCode: '',
            verificationText: '获取验证码',
            guid: '',
            //登录身份证
            loginidcard: ''
        }
    },
    methods: {

        //判断第一步
        // panduanhhh(){
        //     let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
        //     let me = this;
        //     if (!me.loginPhone.trim()) {
        //         me.loginMessage = '手机号不能为空';
        //         me.isLoginMessage = true;
        //         return
        //     } else if (!reg.test(me.loginPhone)) {
        //         me.loginMessage = '手机号格式错误';
        //         me.isLoginMessage = true;
        //         return
        //     }else if (!me.registerCode.trim()) {
        //         me.registerMessage3 = '验证码不能为空';
        //         me.isLoginMessage = false;
        //         me.isRegisterMessage3 = true;
        //         return
        //     }else{
        //         me.isLoginMessage = false;
        //         // me.inputBoo=false;
        //         me.inputBoo1=false;
        //         me.inputBoo2=true;
        //         // this.$post('xxx/xxx',{}).then(res=>{
        //         // })
        //     }
        // },
        //判断第二步
        panduanlll() {
            let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            // 身份证校验
            let reg1 = /^\d{17}(\d|x|X)$/;
            let me = this;
            if (!me.loginidcard.trim()) {
                me.idCardMessage = '身份证不能为空';
                me.isIdCardMessage = true;
                return
            } else if (!reg1.test(me.loginidcard)) {
                me.idCardMessage = '身份证号格式错误';
                me.isIdCardMessage = true;
            } else if (!me.loginPhone.trim()) {
                me.loginMessage = '手机号不能为空';
                me.isLoginMessage = true;
                return
                me.loginMessage = '手机号格式错误';
                me.isLoginMessage = true;
                return
            } else if (!reg.test(me.loginPhone)) {

            } else if (!me.registerCode.trim()) {
                me.registerMessage3 = '验证码不能为空';
                me.isLoginMessage = false;
                me.isRegisterMessage3 = true;
                return
            } else if (me.registerCode.length != 4) {
                me.registerMessage3 = '验证码必须为4位';
                me.isLoginMessage = false;
                me.isRegisterMessage3 = true;
                return
            } else if (!me.registerPassword.trim()) {
                me.registerMessage = '密码不能为空';
                me.isRegisterMessage = true;
                return;
            } else if (!me.registerAffirmPassword.trim()) {
                me.registerMessage1 = '确认密码不能为空';
                me.isRegisterMessage = false;
                me.isRegisterMessage1 = true;
                return;
            } else if (me.registerPassword.trim() !== me.registerAffirmPassword.trim()) {
                me.registerMessage1 = '两次密码不匹配';
                me.isRegisterMessage1 = true;
                return;
            } else {
                me.isRegisterMessage = false;
                me.isRegisterMessage1 = false;
                this.$post('users/set_password', {
                    phone: this.loginPhone,
                    password: this.registerAffirmPassword,
                    code: this.registerCode,
                    guid: this.guid,
                    idCard: this.loginidcard,
                    shop_id: this.$store.state.store.id
                }).then(res => {
                    console.log(res)
                    if (res.data.status == 'success') {
                        me.isyingchang = false;
                        me.inputBoo1 = false;
                    } else if (res.data.status == 'fail') {
                        me.registerMessage3 = res.data.errorMsg;
                        me.isRegisterMessage3 = true;
                    }
                })
            }
        },
        //当身份证聚焦
        forgetFocus() {
            if (this.idCardMessage == '身份证不能为空' || this.idCardMessage == '身份证格式错误') {
                this.isIdCardMessage = false;
                this.idCardMessage = '';
            }
        },
        //当手机号聚焦
        forgetFocus() {
            if (this.loginMessage == '手机号不能为空' || this.loginMessage == '手机号格式错误') {
                this.isLoginMessage = false;
                this.loginMessage = '';
            }
        },
        //验证码聚焦
        yanzhengFocus() {
            if (this.registerMessage3 == '验证码不能为空' || this.registerMessage3 == '验证码错误') {
                this.isRegisterMessage3 = false;
                this.registerMessage3 = '';
            }
        },
        //新密码聚焦
        newpassFocus() {
            if (this.registerMessage == '密码不能为空') {
                this.isRegisterMessage = false;
                this.registerMessage = '';
            }

        },
        //再次密码聚焦
        againpassFocus() {
            if (this.registerMessage1 == '确认密码不能为空' || this.registerMessage1 == '两次密码不匹配') {
                this.isRegisterMessage1 = false;
                this.registerMessage1 = '';
            }
        },
        //验证码
        getVerificationCode: function () {
            let me = this;
            let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            if (me.loginPhone == '') {
                this.loginMessage = '手机号不能为空';
                this.isLoginMessage = true;
                return;
            } else if (!reg.test(me.loginPhone)) {
                me.loginMessage = '手机号格式错误';
                me.isLoginMessage = true;
                return;
            } else {
                if (me.verificationText === '获取验证码') {

                    this.$post('users/sms_send', {
                        phone: this.loginPhone,
                        type: '重置密码',
                        shop_id: this.$store.state.store.id
                    }).then(res => {
                        this.guid = res.data.result;
                    })
                    let time = 60;
                    let timego = setInterval(function () {
                        me.verificationText = time + '秒后重发';
                        --time;
                        if (time < 0) {
                            clearInterval(timego);
                            me.verificationText = '获取验证码';
                        }
                    }, 1000);
                }
            }
        },

        //跳转到主页
        fanhuishouye: function () {
            this.$router.push({
                path: '/'
            });
        },
    },
    mounted: function () {
        document.title = '找回密码';
    }
}
